import type { ResponseMESF } from "@dexteel/mesf-core";
import {
  getLocationsDropdown,
  getYardHeats,
  getGrades,
  getSections,
  getLengths,
  getBilletQualityStatuses,
} from "../../../../repository/BilletYardInventoryRepository";

// Generic dropdown item interface for search data
export interface DropdownItem {
  Title?: string;
  Name?: string;
  HeaderText?: string;
  Description?: string;
  Text?: string;
  [key: string]: unknown;
}

/**
 * Extract rows from API response
 */
export const extractRows = (resp: ResponseMESF): DropdownItem[] =>
  resp.ok ? resp.data?.tables?.[0]?.rows || [] : [];

/**
 * Filter out "Unknown" values from data array and log results
 */
export const filterUnknownOnly = (
  data: DropdownItem[],
  category: string,
): DropdownItem[] => {
  const originalCount = data.length;
  const filtered = data.filter((item) => {
    // Get the display text/title of the item
    const displayText =
      item.Title ||
      item.Name ||
      item.HeaderText ||
      item.Description ||
      item.Text ||
      "";
    // Only filter out if the display text is exactly "Unknown" (case-insensitive)
    const isUnknown = displayText.toLowerCase().trim() === "unknown";
    return !isUnknown;
  });
  const filteredCount = filtered.length;
  const removedCount = originalCount - filteredCount;

  // Log handling for filtered items removed

  return filtered;
};

/**
 * Load all dropdown data from API endpoints
 */
export const loadAllDropdownData = async () => {
  const [
    locationsResult,
    heatsResult,
    gradesResult,
    sectionsResult,
    lengthsResult,
    qualitiesResult,
  ] = await Promise.all([
    getLocationsDropdown(),
    getYardHeats(),
    getGrades(),
    getSections(),
    getLengths(),
    getBilletQualityStatuses(),
  ]);

  return {
    locations: filterUnknownOnly(extractRows(locationsResult), "Locations"),
    heats: filterUnknownOnly(extractRows(heatsResult), "Heats"),
    grades: filterUnknownOnly(extractRows(gradesResult), "Grades"),
    sections: filterUnknownOnly(extractRows(sectionsResult), "Sections"),
    lengths: filterUnknownOnly(extractRows(lengthsResult), "Lengths"),
    qualities: filterUnknownOnly(extractRows(qualitiesResult), "Qualities"),
  };
};
